import $ from 'jquery';

$(document).ready(function() {
	$('.js-exponat-slider').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
	  });

	$('.js-exponat-slider-new').slick({
		dots: true,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
	  });

	$(".b-exponat-article--overlay").css("height", $(".b-exponat-article").outerHeight() + 5);
});


// WEBPACK FOOTER //
// ./src/js/pages/one-exponat/slide-exponat.js